import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'app-estadisticas-designacion-cpd',
    templateUrl: './estadisticas-designacion-cpd.component.html'
})
export class EstadisticasDesignacionCPDComponent implements OnInit {

    public estadisticas;

    public tipoEstadisticas = 1;

    @Input() graficasDesignacionesFiltroCompleto;
    @Input() filtrado;

    @Output() showWarning = new EventEmitter<any>();

    constructor(
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.showDesignacionesEtiquetadores();
    }

    public async showDesignacionesEtiquetadores() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 4;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false
        });
    }

    public async showKilosPais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 5;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false
        });
    }

    public async showKilosDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 6;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false
        });
    }

    public async showKilosEtiquetadores() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 8;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false
        });
    }

    public delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }
}
